module.exports = __webpack_public_path__ + "static/media/feed-card-1.4162231f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feed-card-1.png
// module id = 504
// module chunks = 0